import { Component, Input, OnInit } from '@angular/core';
import { Creative } from './../../../interfaces/adservices';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'vast-details-metadata',
	templateUrl: './vast-details-metadata.component.html',
	styleUrls: ['./vast-details-metadata.component.scss']
})


export class VastDetailsMetadataComponent implements OnInit {

	@Input() creative: Creative;
	@Input() form: NgForm;
	justAddedIndex: number;

	constructor() {

	}

	ngOnInit() {
		// this.parentForm.addFormGroup(this.myFormGroup)
	}

	isString(o: any) {
		return (typeof o === 'string');
	}

	addTracker(eventType = '') {
		if (!this.creative || !this.creative.eventTrackers) {
			this.creative.eventTrackers = [];
		}

		this.creative.eventTrackers.push({ eventType, url: '' });
		this.justAddedIndex = this.creative.eventTrackers.length - 1;
		this.form.form.markAsDirty();
	}

	removeTracker(index: number) {
		this.creative.eventTrackers.splice(index, 1);
		this.form.form.markAsDirty();
	}

	addAdVerification() {
		if (!this.creative.omidAdVerifications) {
			this.creative.omidAdVerifications = [];
		}
		this.creative.omidAdVerifications.push({
			vendor: '',
			scriptUrl: ''
		});
		this.form.form.markAsDirty();
	}

	removeAdVerification(index: number) {
		this.creative.omidAdVerifications.splice(index, 1);
		this.form.form.markAsDirty();
	}
}
